import React from 'react'
import { LvpMarginWrapper } from '../Layouts/LargeVideoPlayerLayout'
import * as Styled from './styled'

interface MaxWidthContainerProps {
  children: React.ReactNode
}

const MaxWidthContainer: React.FC<MaxWidthContainerProps> = ({ children }) => (
  <Styled.Container>
    <LvpMarginWrapper>
      <Styled.Wrapper>{children}</Styled.Wrapper>
    </LvpMarginWrapper>
  </Styled.Container>
)

export default MaxWidthContainer
